import type { FeatureControlResponseData } from './types';

export function normalize(
  res: FeatureControlResponseData,
): FeatureControlResponseData {
  return res;
}
